//@ts-nocheck
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { CandidateResponse, CandidateState } from './taskTypes';
import { ApiError } from '../jobAuth/JobAuthTypes';
import { applyApplicationQuestionSetById, createApplicationQuestionTask, fetchMeetingDetails, fetchTaskList } from '../../../services/taskService';



export const taskListData = createAsyncThunk<
  Job,
  { appId: string },
  { rejectValue: string }
>('jobs/taskListData', async ({ appId }, { rejectWithValue }) => {
  try {
    const response = await fetchTaskList(appId);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || 'Failed to fetch task list');
  }
});

//fetchMeetingDetails 
export const fetchMeeting = createAsyncThunk<
  CandidateResponse,
  { typeId: string },
  { rejectValue: ApiError }
>('jobs/fetchMeeting', async ({ typeId }, { rejectWithValue }) => {
  try {
    const response = await fetchMeetingDetails(typeId);
    return response;
  } catch (error: any) {    
    return rejectWithValue(error.response?.data || 'Failed to fetch meeting details');
  }
});


export const applyApplicationQuestion = createAsyncThunk<
  Job,
  { id: string; }, // Accept token
  { rejectValue: string }
>('jobs/applyApplicationQuestion', async ({ id }, { rejectWithValue }) => {
  try {
    const response = await applyApplicationQuestionSetById(id);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data || 'Failed to apply for the job');
  }
});

// Create Application Thunk
export const createApplicationQuestion = createAsyncThunk<
  CandidateResponse,
  {
    job_id: string;
    base_slug: string;
    app_id: string;
    app_email: string;
    name?: string;
    phone?: string;
    location?: string;
    summary?: string;
    education?: any;
    experience?: any;
    links?: string[];
    resume?: string;
    cover_letter?: string;
  },
  { rejectValue: string }
>(
  'candidate/createApplicationQuestion',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createApplicationQuestionTask(payload, payload.questionId);

      return response;
    } catch (err) {
      const error = err as ApiError;
      return rejectWithValue(error.response?.data?.message || 'Application creation failed');
    }
  }
);


const initialState: CandidateState = {
  taskListData: null,
  taskListDataStatus: 'idle',
  taskListDataError: null,
  fetchMeetingStatus: 'idle',
  fetchMeetingError: null,
  fetchMeetingData: null,
  applyApplicationQuestionStatus: 'idle',
  applyApplicationQuestionError: null,
  applyApplicationQuestionData: null,
  createApplicationQuestionStatus: 'idle',
  createApplicationQuestionError: null,
  createApplicationQuestionData: null
};

const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(taskListData.pending, (state) => {
        state.taskListDataStatus = 'loading';
      })
      .addCase(taskListData.fulfilled, (state, action: PayloadAction<Job>) => {
        state.taskListDataStatus = 'succeeded';
        state.taskListData = action.payload;
      })
      .addCase(taskListData.rejected, (state, action: PayloadAction<string>) => {
        state.taskListDataStatus = 'failed';
        state.taskListDataError = action.payload;
      })
      .addCase(fetchMeeting.pending, (state) => {
        state.fetchMeetingStatus = 'loading';
      })
      .addCase(fetchMeeting.fulfilled, (state, action: PayloadAction<CandidateResponse>) => {
        state.fetchMeetingStatus = 'succeeded';
        state.fetchMeetingData = action.payload;
      })
      .addCase(fetchMeeting.rejected, (state, action: PayloadAction<ApiError>) => {
        state.fetchMeetingStatus = 'failed';
        state.fetchMeetingError = action.payload?.response?.data?.message || 'Failed to fetch meeting details';
      })
      .addCase(applyApplicationQuestion.pending, (state) => {
        state.applyApplicationQuestionStatus = 'loading';
      })
      .addCase(applyApplicationQuestion.fulfilled, (state, action: PayloadAction<Job>) => {
        state.applyApplicationQuestionStatus = 'succeeded';
        state.applyApplicationQuestionData = action.payload;
      })
      .addCase(applyApplicationQuestion.rejected, (state, action: PayloadAction<string>) => {
        state.applyApplicationQuestionStatus = 'failed';
        state.applyApplicationQuestionError = action.payload;
      })
      .addCase(createApplicationQuestion.pending, (state) => {
        state.createApplicationQuestionStatus = 'loading';
      })
      .addCase(createApplicationQuestion.fulfilled, (state, action: PayloadAction<CandidateResponse>) => {
        state.createApplicationQuestionStatus = 'succeeded';
        state.createApplicationQuestionData = action.payload;
      })
      .addCase(createApplicationQuestion.rejected, (state, action: PayloadAction<string>) => {
        state.createApplicationQuestionStatus = 'failed';
        state.createApplicationQuestionError = action.payload;
      });
  },
});

export default taskSlice.reducer;
